import { render, staticRenderFns } from "./CAvisoPendiente.vue?vue&type=template&id=7fc70160&"
import script from "./CAvisoPendiente.vue?vue&type=script&lang=js&"
export * from "./CAvisoPendiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports